export default __webpack_public_path__ + "static/media/gallery_g-min.b20b9e8c.jpg";